module.exports = __webpack_public_path__ + "static/media/greeting-1.1a7177ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/greeting-1.png
// module id = 577
// module chunks = 0